import type { ReactNode } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

interface ISortContainerProps {
  children: ReactNode;
  id: string;
  items: { [key: string]: any; id: string }[];
  className?: string;
  disabled?: boolean;
  dropDisabled?: boolean;
}

const SortContainer = ({
  children,
  className,
  disabled,
  dropDisabled,
  id,
  items,
}: ISortContainerProps) => {
  const { setNodeRef } = useDroppable({ id, disabled: dropDisabled });
  return (
    <SortableContext
      disabled={disabled}
      id={id}
      items={items}
      strategy={verticalListSortingStrategy}
    >
      <div ref={setNodeRef} className={className}>
        {children}
      </div>
    </SortableContext>
  );
};

export default SortContainer;
